import NamedDto from 'modules/base/dto/NamedDto';

export class ModelValidationLogEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.tableName = null;
		/** @type {string} */
		this.description = null;
		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _ModelValidationLogEditDtoProps
	 * @property {string} tableName
	 * @property {string} description
	 * @property {number} userGroup
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _ModelValidationLogEditDtoProps} ModelValidationLogEditDtoProps
	 */
	/**
	 *
	 * @param {ModelValidationLogEditDtoProps} props
	 * @returns {ModelValidationLogEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.tableName = props.tableName;
		this.description = props.description;
		this.userGroup = props.userGroup;

		return this;
	}
}

export default ModelValidationLogEditDto;